// @ts-strict-ignore
import { MetaElementUsageUtils } from '../../util/meta-element-usage-utils';
import { MetaElementUsageIdentityVO, TextureAreaUsageVO, TextValueVO } from '@shared/vo/meta-element.vo';

export class LabelingTextureData {
  private _previousMetaUsageId: MetaElementUsageIdentityVO;
  private _nextMetaUsageId: MetaElementUsageIdentityVO;
  private _textValue: TextValueVO;

  public constructor(textureUsage: TextureAreaUsageVO = null) {
    if (textureUsage != null) {
      this._previousMetaUsageId = this.cloneMetaElementIdentity(textureUsage.previousMergedUsageId);
      this._nextMetaUsageId = this.cloneMetaElementIdentity(textureUsage.nextMergedUsageId);
      this._textValue = !textureUsage.textValue ? null : textureUsage.textValue.clone();
    }
  }

  public get previousMetaUsageId(): MetaElementUsageIdentityVO {
    return this._previousMetaUsageId;
  }

  public set previousMetaUsageId(metaId: MetaElementUsageIdentityVO) {
    this._previousMetaUsageId = metaId;
  }

  public get nextMetaUsageId(): MetaElementUsageIdentityVO {
    return this._nextMetaUsageId;
  }

  public set nextMetaUsageId(metaId: MetaElementUsageIdentityVO) {
    this._nextMetaUsageId = metaId;
  }

  public get textValue(): TextValueVO {
    return this._textValue;
  }

  public equals(data: LabelingTextureData): boolean {
    if (!data) {
      return false;
    }
    return MetaElementUsageUtils.isMetaElementUsageIdentityEquals(this._previousMetaUsageId, data._previousMetaUsageId)
      && MetaElementUsageUtils.isMetaElementUsageIdentityEquals(this._nextMetaUsageId, data._nextMetaUsageId)
      && this.equalsTextValue(this._textValue, data._textValue);
  }

  private equalsTextValue(value1: TextValueVO, value2: TextValueVO): boolean {
    if (!value1 && !value2) {
      return true;
    }
    if (!value1 && value2) {
      return false;
    }
    return value1.equals(value2);
  }

  private cloneMetaElementIdentity(identity: MetaElementUsageIdentityVO): MetaElementUsageIdentityVO {
    if (!identity) {
      return null;
    }
    return MetaElementUsageIdentityVO.create(identity.articleUsageId, identity.metaElementName);
  }
}
